export const LOG_COLUMNS = [
  {
    title: '门店名称',
    key: 'store_name',
    minWidth: 130,
  },
  {
    title: '类型',
    key: 'type',
    minWidth: 130,
  },
  {
    title: '原所属渠道',
    key: 'old_channel_name',
    minWidth: 130,
  },
  {
    title: '原上级门店',
    key: 'old_parent_name',
    minWidth: 130,
  },
  {
    title: '新所属渠道',
    key: 'new_channel_name',
    minWidth: 130,
  },
  {
    title: '新上级门店',
    key: 'new_parent_name',
    minWidth: 130,
  },
  {
    title: '操作人类型',
    key: 'opt_group_type',
    minWidth: 120,
  },
  {
    title: '操作人',
    key: 'opt_nick_name',
    minWidth: 140,
  },
  {
    title: '操作时间',
    key: 'create_time',
    minWidth: 180,
  },
];
